import { useParams } from "react-router-dom";
import Kubernetes from "./Kubernetes";
import CloudManagement from "./CloudManagement";
import Serverless from "./Serverless";
import Databases from "./Databases";
import AICloudAutomation from "./AICloudAutomation";
import IoT from "./IoT";
import iam from "./IAM";
import AITraining from "./AITraining";
import Ann from "./aimodels/ann"; // Import model components
import Cnn from "./aimodels/cnn";
import Transformer from "./aimodels/transformer";

const topicComponents = {
  kubernetes: Kubernetes,
  "cloud-management": CloudManagement,
  serverless: Serverless,
  databases: Databases,
  "ai-cloud-automation": AICloudAutomation,
  iot: IoT,
  iam: iam,
  "ai-training": AITraining,
  ann: Ann, // Add model subtopics
  cnn: Cnn,
  transformer: Transformer
};

const TopicPage = () => {
  const { topicId } = useParams();
  const TopicComponent = topicComponents[topicId.toLowerCase()]; // Ensure case-insensitive matching

  return TopicComponent ? <TopicComponent /> : <h1 className="text-2xl font-bold text-red-600">404 - Topic Not Found</h1>;
};

export default TopicPage;